
















































































import { Component, Vue, Prop } from "vue-property-decorator";
import PriceChart from "./PriceChart.vue";
import { Getter } from "vuex-class";

@Component({
  components: {
    PriceChart
  }
})
class AssetItem extends Vue {
  @Getter("trade/getThumbnailById") getThumbnailById;

  @Prop() expandAsset;

  @Prop() asset;

  get meta() {
    const {
      asset_symbol,
      asset_icon,
      change,
      price,
      asset_id,
      swap_via_crypto,
      swap_via_fiat
    } = this.asset;
    const fiatPrice = this.$common.utils.currency.fiat(this, {
      from: "CNY",
      value: price
    });
    const priceColor = this.$common.utils.helper.getColor(this.$store, change);
    const prices = this.getThumbnailById(asset_id);
    return {
      swapViaCrypto: swap_via_crypto,
      swapViaFiat: swap_via_fiat,
      prices,
      expand: this.expandAsset === asset_symbol,
      symbol: asset_symbol,
      icon: asset_icon,
      change: this.$common.utils.number.toPercent(change, true),
      price: fiatPrice,
      color: priceColor
    };
  }

  handleToInstant() {
    this.$helper.toFusionPath(this, "trade", {
      name: "instant",
      query: { wanted: this.asset.asset_symbol }
    });
  }

  handleToAuto() {
    this.$helper.toFusionPath(this, "trade", {
      name: "fiat-wyre",
      query: { wanted: this.asset.asset_id }
    });
  }

  handleClick() {
    this.$emit("expand", this.meta.symbol);
  }
}
export default AssetItem;
